import { Switch as MantineSwitch, SwitchProps } from '@mantine/core';

export type ISwitchProps = SwitchProps;

/** @registry Design-layer pass-through over Mantine Switch; import this instead of @mantine/core Switch outside src/design. Extend here when Switch needs house behavior. */
export const Switch = MantineSwitch;
